<template>
  <ow003 :schema="schema" :applicant="applicant" :student="student" :school="school">
    <template slot="deviationsOrEvents">
      <div class="row form-group">
        <w-datepicker
          class="col-4"
          :date-options="{
            disableDatesFromWarnings: true
          }"
          :model="schema.data.randomEventDate"
        />
      </div>

      <div class="form-group">
        <label>{{ schema.data.randomAccidentsSingle.$title }}</label>

        <w-radio
          v-for="(item, index) in typeOfAccidents"
          :key="index + '.accident'"
          class="mb-1"
          :model="schema.data.randomAccidentsSingle"
          :value="item.value"
          :title="item.text"
          :show-error="false"
        />

        <w-error :model="schema.data.randomAccidentsSingle" />
      </div>

      <w-input v-if="randomAccidentsSelected" :model="schema.data.otherAccidents" />

      <w-input :model="schema.data.accidentCost" />
    </template>

    <template slot="support">
      <w-checkbox
        v-for="(item, index) in typeOfBenefitForms"
        :key="index + '.benefitform'"
        :model="schema.data.benefitForm"
        :disabled="item.value === 1"
        :value="item.value"
        :title="item.text"
      />
    </template>
  </ow003>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import { ow003Mixin } from '@/mixins/document/ow003';
import Ow003 from './OW-003';

// @vuese
// OW-003 Zasiłki
// @group templates
export default {
  components: { Ow003, ...components },
  mixins: [ow003Mixin],
  props: {
    // schema dokumentu
    schema: { type: Object, required: true },
    // dane ucznia
    student: { type: Object, required: false },
    // dane wnioskodawcy
    applicant: { type: Object, required: false },
    // dane szkoły
    school: { type: Object, required: false }
  }
};
</script>
